import { Field, Formik } from "formik";
import { useEffect, useRef, useState } from "react";
import * as Yup from "yup";
import LabelWithTick from "../../RequestModal/Adwords/helper";
import FormError from "../../RequestModal/FormError";
import greenTick from "../../../assets/images/modal/tick.svg";
import disableIcon from "../../../assets/images/Disable.svg";
import validIcon from "../../../assets/images/Valid.svg";
import "./QueryForm.scss";
import "../../LeadsSubmissionForm/styles.scss";
import "react-phone-number-input/style.css";
import Phone, { isValidPhoneNumber } from "react-phone-number-input";
import "react-phone-input-2/lib/style.css";
import OTPInput from "react-otp-input";
import { CountdownCircleTimer } from "react-countdown-circle-timer";
import chevronRightEnabled from "../../../assets/images/chevron_right_blue.svg";
import chevronRightDisabled from "../../../assets/images/chevron_right_disabled.svg";
import { verifyGstApi } from "../../../services/GSTService";
import {
  createLeadApi,
  getLeadProductList,
  productLeadEmail,
  updateLeadApi,
} from "../../../services/LeadsService";
import { sendOtpApi, verifyOtpApi } from "../../../services/AuthService";
import { maskMobileNumber } from "../../../generic";
import { Select } from "antd";
import BACKGROUND_IMAGE from "../../../assets/images/denim/Form_BackGround.webp";
import { GST_NUMBER_REGEX } from "../../../pages/News/constants";

const OTP_LENGTH = 4;

const DENIM_FILTERED_QUANTITY = 8;

const LEAD_TITLE_TEXT = [
  "Fill your details",
  "Verify Mobile Number",
  "Share your requirement",
  "Verify your business details",
];

const LEADS_SUBMIT_TEXT = ["Submit", "Verify number", "Proceed", "Submit"];

const REQUIRED_QUANTITY = [
  {
    label: "< 2,000 m",
    minQuantity: 0,
    maxQuantity: 2000,
  },
  {
    label: "2,000 m to 5,000 m",
    minQuantity: 2000,
    maxQuantity: 5000,
  },
  {
    label: "5,000 m to 10,000 m",
    minQuantity: 5000,
    maxQuantity: 10000,
  },
  {
    label: "10,000 m +",
    minQuantity: 10000,
    maxQuantity: null,
  },
];

const BUSINESS_NATURE = {
  1: "Manufacturer",
  2: "Trader",
};

const GST_VERIFIED = {
  isVerified: 1,
  isNotVerified: 0,
};

const MOBILE_VERIFIED = {
  isVerified: 1,
  isNotVerified: 0,
};

export const PRODUCT_LEAD_TYPE = {
  Cotton: 1,
  Rayon: 2,
  Denim: 3,
  Polyester: 4,
};

// const REQUIREMENT_TYPES = ["Bottomwear", "Topwear"];

const DENIM_COLOR_LIST = ["Indigo", "Blue", "Black", "IBST", "Ecru", "Others"];

const getValuesFromParams = () => {
  const params = new URLSearchParams(window.location.search);

  return {
    name: params.get("name") || "",
    workEmail: params.get("workEmail") || "",
    mobileNumber: params.has("mobileNumber") ? params.get("mobileNumber") : "",
    companyName: params.has("companyName") ? params.get("companyName") : "",
    isMobileVerified:
      Number(params.get("isMobileVerified")) || MOBILE_VERIFIED.isNotVerified,
    // requirementType: params.get("requirementType") || "",
    product: params.has("product") ? params.get("product") : "",
    color: params.has("color") ? params.get("color") : "",
    customColorValue: params.has("customColorValue")
      ? params.get("customColorValue")
      : "",
    quantity: "",
    minQuantity: null,
    maxQuantity: null,
    businessNature: params.get("businessNature") || "",
    gstNumber: params.get("gstNumber") || "",
    isGstVerified:
      Number(params.get("isGstVerified")) || GST_VERIFIED.isNotVerified,
    productLeadType:
      Number(params.get("productLeadType")) || PRODUCT_LEAD_TYPE.Denim,
  };
};

const updateParams = (values) => {
  const params = new URLSearchParams(window.location.search);

  Object.entries(values).forEach(([key, value]) => {
    if (
      value !== "" &&
      value !== null &&
      value !== undefined &&
      key != "product"
    ) {
      params.set(key, value);
    }
  });

  window.history.replaceState(null, "", `?${params.toString()}`);
};

const setKeyInParams = (key, value) => {
  const params = new URLSearchParams(window.location.search);
  params.set(key, value);
  window.history.replaceState(null, "", `?${params.toString()}`);
};

const INITIAL_VALUES = {
  name: "",
  workEmail: "",
  mobileNumber: "",
  companyName: "",
  isMobileVerified: MOBILE_VERIFIED["isNotVerified"],
  // requirementType: "",
  color: "",
  customColorValue: "",
  product: "",
  customProductValue: "",
  quantity: "",
  minQuantity: null,
  maxQuantity: null,
  businessNature: "",
  gstNumber: "",
  isGstVerified: GST_VERIFIED["isNotVerified"],
  productLeadType: PRODUCT_LEAD_TYPE["Denim"],
  pincode: null,
};

const STEP_VALIDATION = [
  Yup.object({
    name: Yup.string().trim().required("Name is required"),
    workEmail: Yup.string()
      .email("Please enter valid email")
      .required("Please enter your email"),
    mobileNumber: Yup.string()
      .required("Mobile number is required")
      .test("valid-phone", "Enter valid phone number", (v) =>
        isValidPhoneNumber(`${v}`),
      ),
    companyName: Yup.string().trim().required("Please enter your company name"),
  }),
  Yup.object({}),
  Yup.object({
    // requirementType: Yup.string().required("Select requirement type"),
    product: Yup.mixed().nullable(),
    color: Yup.string().required("Select color"),
    quantity: Yup.string().required("Select quantity"),
  }).test("custom-validation", null, function (values) {
    const errors = {};
    if (values.color === "Others" && !values.customColorValue) {
      errors.color = "Please enter a color";
    }
    if (!values.product) {
      errors.product = "Please enter a product";
    }
    if (Object.keys(errors).length) {
      return this.createError({ message: JSON.stringify(errors) });
    }
    return true;
  }),
  Yup.object({
    gstNumber: Yup.string()
      .matches(GST_NUMBER_REGEX, "Please enter a valid GST number")
      .required("GST number is required"),
    businessNature: Yup.string().required("Select business nature"),
    pincode: Yup.string()
      .typeError("Please enter a valid Pincode")
      .matches(/^[1-9]\d{5}$/, "Please enter a valid Pincode")
      .required("Please enter your pincode"),
  }),
];

const FormikUrlSync = ({ values }) => {
  useEffect(() => {
    updateParams(values);
  }, [values]);

  return null;
};

const ProductLabel = ({ label, className }) => {
  if (!label) return null;

  const parts = label.split(",");

  return (
    <span className="productLabel">
      {parts.map((part, index) => (
        <span key={index} className="productLabelItem">
          <span className={className}>{part.trim()}</span>
          {index < parts.length - 1 && (
            <span className="productSeparator">|</span>
          )}
        </span>
      ))}
    </span>
  );
};

const QueryForm = ({
  requirementFormClass = {},
  footerClass = {},
  productRequiredQuantity = REQUIRED_QUANTITY,
  // productRequirementTypes = REQUIREMENT_TYPES,
  productLeadType = PRODUCT_LEAD_TYPE["Denim"],
  productColors = DENIM_COLOR_LIST,
  backgroundImage = BACKGROUND_IMAGE,
}) => {
  const params = new URLSearchParams(window.location.search);
  const [step, setStep] = useState(0);
  const [submitText, setSubmitText] = useState(LEADS_SUBMIT_TEXT[step]);
  const [titleText, setTitleText] = useState(LEAD_TITLE_TEXT[step]);
  // const [showOTPError, setShowOTPError] = useState(null);
  const [mobile, setMobile] = useState(params.get("mobileNumber") || null);
  // const [otp, setOtp] = useState("");
  // const [actionButtonsDisabled, setActionButtonsDisabled] = useState(true);
  const [isGstVerified, setIsGstVerified] = useState(null);
  const [gstNumberErrorMessage, setGstNumberErrorMessage] = useState(null);
  const formContentRef = useRef();
  const [isSubmitSuccessful, setIsSubmitSuccessful] = useState(false);
  const [initialValues, setInitialValues] = useState(INITIAL_VALUES);
  const [hydrated, setHydrated] = useState(false);
  const [submitButtonClicked, setSubmitButtonClicked] = useState(false);
  const [leadCompanyName, setLeadCompanyName] = useState(
    params.has("leadCompanyName") ? params.get("leadCompanyName") : "",
  );
  const [currentLeadId, setCurrentLeadId] = useState(
    params.has("currentLeadId") ? params.get("currentLeadId") : null,
  );
  const [pincode, setPincode] = useState(
    params.has("pincode") ? params.get("pincode") : null,
  );
  const [productQualities, setProductQualities] = useState([]);
  const [preferredWeightRange, setPreferredWeightRange] = useState(
    params.has("preferredWeightRange")
      ? params.get("preferredWeightRange")
      : null,
  );
  const filteredProductQualities = productQualities.filter((item) => {
    if (!preferredWeightRange) return true;

    const weight = Number(item?.beforeWashWeight);

    if (Number.isNaN(weight)) return false;

    if (preferredWeightRange === "LESS") {
      return weight < DENIM_FILTERED_QUANTITY;
    }

    if (preferredWeightRange === "MORE") {
      return weight >= DENIM_FILTERED_QUANTITY;
    }

    return true;
  });

  const productOptions = filteredProductQualities.map((item) => ({
    label: item.productName,
    value: item.id,
  }));

  const [productName, setProductName] = useState(null);

  const formikRef = useRef(null);
  const [customColor, setCustomColor] = useState(
    params.has("color") ? params.get("color") : "",
  );
  const [customProduct, setCustomProduct] = useState(
    params.has("product") ? params.get("product") : "",
  );
  const productOptionsWithOther = [
    ...productOptions,
    { label: "Others", value: "Others" },
  ];

  // const onResendClick = async () => {
  //   try {
  //     const otpApiPayload = {
  //       mobileNumber: mobile?.slice(3),
  //     };
  //     await sendOtpApi(otpApiPayload);
  //     setActionButtonsDisabled(true);
  //   } catch (err) {
  //     console.log("Error occurred in resending the otp: ", err);
  //   }
  // };

  // const onResendWaitComplete = () => {
  //   setActionButtonsDisabled(false);
  // };

  const handleSubmitStepZero = async (values, actions) => {
    if (submitButtonClicked) return;
    try {
      setSubmitButtonClicked(true);
      const payload = {
        name: values?.values?.name,
        workEmail: values?.values?.workEmail,
        mobileNumber: values?.values?.mobileNumber,
        tradeName: values?.values?.companyName,
        productLeadType: values?.values?.productLeadType,
        stepNumber: Number(step) + 1,
      };
      if (!currentLeadId) {
        const result = await createLeadApi(payload);
        setCurrentLeadId(result?.data?.id);
        params.set("currentLeadId", result?.data?.id);
      } else {
        await updateLeadApi(currentLeadId, payload);
      }
      window.history.replaceState(null, "", `?${params.toString()}`);
      // const otpApiPayload = {
      //   mobileNumber: values?.values?.mobileNumber?.slice(3), // removing country code: +91
      // };
      // const OtpApiResponse = await sendOtpApi(otpApiPayload);
      updateParams(values?.values);
      // return OtpApiResponse;
    } catch (err) {
      console.log("error: ", err);
      throw new Error("Error occurred while creating the lead: ", err);
    }
  };

  // const handleSubmitStepFirst = async (values, actions, otpValue = null) => {
  //   try {
  //     const otpToUse = otpValue || otp;
  //     const payload = {
  //       mobileNumber:
  //         mobile?.slice(3) || values?.values?.mobileNumber?.slice(3), // removing country code: +91
  //       otp: otpToUse,
  //       id: currentLeadId,
  //     };
  //     const verifyOtpResponse = await verifyOtpApi(payload);
  //     if (verifyOtpResponse.success) {
  //       const LeadPayload = {
  //         isMobileVerified: MOBILE_VERIFIED.isVerified,
  //         stepNumber: Number(step) + 1,
  //       };
  //       await updateLeadApi(currentLeadId, LeadPayload);
  //       if (otpValue != null) {
  //         setStep(2);
  //       }
  //     } else {
  //       if (
  //         verifyOtpResponse?.message ==
  //         `We couldn't find any otp for this number. Please request an OTP again.`
  //       ) {
  //         setShowOTPError(verifyOtpResponse?.message);
  //       } else {
  //         setShowOTPError("Incorrect OTP Entered");
  //       }
  //       setTimeout(() => {
  //         setShowOTPError(false);
  //       }, 5000);
  //     }
  //     updateParams(values?.values);
  //     return verifyOtpResponse;
  //   } catch (err) {
  //     setShowOTPError(true);
  //     console.log("error: ", err);
  //   }
  // };

  const handleSubmitStepSecond = async (values, actions) => {
    try {
      const colorToSend =
        values.values.color === "Others"
          ? values.values.customColorValue
          : values.values.color;

      const productToSend =
        values.values.product === "Others" ? "Others" : productName;

      let payload = {
        minQuantity: values?.values?.minQuantity,
        maxQuantity: values?.values?.maxQuantity,
        color: colorToSend,
        productQualitiesId:
          values?.values?.product != "Others" ? values?.values?.product : null,
        product: productToSend,
        stepNumber: Number(step) + 1,
      };

      setKeyInParams("color", colorToSend);
      setKeyInParams("product", values?.values?.product);

      const response = await updateLeadApi(currentLeadId, payload);
      updateParams(values?.values);
      return response;
    } catch (err) {
      console.log("error: ", err);
    }
  };

  const handleSubmitStepThird = async (values, actions) => {
    try {
      const payload = {
        businessNature: values?.values?.businessNature,
        gstNumber: values?.values?.gstNumber,
        pincode: values?.values?.pincode || pincode,
        stepNumber: Number(step) + 1,
        // isMobileVerified: MOBILE_VERIFIED.isVerified,
        isGstVerified: isGstVerified
          ? GST_VERIFIED.isVerified
          : GST_VERIFIED.isNotVerified,
        tradeName:
          leadCompanyName !== ""
            ? leadCompanyName
            : values?.values?.companyName,
      };
      const response = await updateLeadApi(currentLeadId, payload);
      updateParams(values?.values);
      return response;
    } catch (err) {
      console.log("error: ", err);
    }
  };

  const handleGSTVerification = async (gstNumber, setFieldValue) => {
    if (!gstNumber) return;
    try {
      const res = await verifyGstApi(gstNumber);
      if (res?.success) {
        const gstPincode =
          res?.data?.address?.city?.pincode ||
          res?.data?.address?.pincode ||
          null;
        if (gstPincode) {
          setPincode(gstPincode);
          setFieldValue("pincode", gstPincode);
        }
        setFieldValue("isGstVerified", 1);
        setFieldValue("gstNumber", gstNumber);
        setIsGstVerified(true);
        setLeadCompanyName(res?.data?.tradeName);
        params.set("leadCompanyName", res?.data?.tradeName);
        params.set("gstNumber", gstNumber);
      } else {
        setIsGstVerified(false);
        setGstNumberErrorMessage(
          res?.message ||
            res?.data?.message ||
            "GST Number Verification Failed",
        );
        if (res?.message == "Some entities failed, please check") {
          setGstNumberErrorMessage("Please Enter a valid GST Number");
        }
      }
    } catch (err) {
      setIsGstVerified(false);
      setGstNumberErrorMessage("GST Number Verification Failed");
    }
  };

  const handleSubmit = async (values, actions) => {
    try {
      if (step === 0) {
        const res = await handleSubmitStepZero(values, actions);
        // if (res.ok) {
        setStep(2);
        // }
        return;
      }

      // if (step === 1) {
      //   const res = await handleSubmitStepFirst(values, actions);
      //   if (res.success) {
      //     setStep(2);
      //   }
      //   return;
      // }

      if (step === 2) {
        const res = await handleSubmitStepSecond(values, actions);
        if (res.success) {
          setStep(3);
        }
        return;
      }

      if (step === 3) {
        const res = await handleSubmitStepThird(values, actions);
        if (res.success) {
          window.history.replaceState(null, "", window.location.pathname);
          setStep(4);
          setIsSubmitSuccessful(true);

          const finalColor =
            values?.values?.color === "Others"
              ? values?.values?.customColorValue
              : values?.values?.color;

          const finalProduct =
            values?.values?.product === "Others"
              ? "Others"
              : (productName ?? values?.values?.product);

          let emailPayload = {
            ...values?.values,
            tradeName:
              leadCompanyName !== ""
                ? leadCompanyName
                : values?.values?.companyName,
            // isMobileVerified: MOBILE_VERIFIED.isVerified,
            isGstVerified: isGstVerified
              ? GST_VERIFIED.isVerified
              : GST_VERIFIED.isNotVerified,
            color: finalColor,
            product: finalProduct,
          };

          await productLeadEmail(emailPayload);
          const payload = {
            isMailSent: 1,
          };
          await updateLeadApi(currentLeadId, payload);
        }
        return;
      }
    } catch (err) {
      console.error(err);
    } finally {
      actions.setSubmitting(false);
    }
  };

  // const handleRequirementTypeChange = async (
  //   productLeadType,
  //   requirementType,
  // ) => {
  //   try {
  //     const payload = {
  //       productType: productLeadType,
  //       requirementType,
  //     };
  //     const result = await getLeadProductList(payload);
  //     if (result?.data) {
  //       setProductQualities(result.data);
  //     }
  //   } catch (err) {
  //     console.log("Error fetching product list: ", err);
  //   }
  // };

  useEffect(() => {
    if (!hydrated) return;
    setSubmitText(LEADS_SUBMIT_TEXT[step]);
    setTitleText(LEAD_TITLE_TEXT[step]);
    if (step == 4) {
      setStep(0);
      window.history.replaceState(null, "", `?${params.toString()}`);
    }
    const run = async () => {
      try {
        const payload = {
          productType: productLeadType,
        };
        const result = await getLeadProductList(payload);
        if (result?.data) {
          setProductQualities(result.data);
        }
      } catch (err) {
        console.log("error: ", err);
      }
    };
    if (step === 2) {
      run();
    }
    setKeyInParams("step", step);
  }, [step, hydrated]);

  useEffect(() => {
    if (!submitButtonClicked) return;
    setTimeout(() => {
      setSubmitButtonClicked(false);
    }, 3000);
  }, [submitButtonClicked]);

  useEffect(() => {
    const savedStep = Number(params.get("step"));

    // if (!Number.isNaN(savedStep)) {
    //   setStep(savedStep);
    // }

    setHydrated(true);

    setInitialValues({
      ...INITIAL_VALUES,
      ...getValuesFromParams(),
    });
  }, []);

  useEffect(() => {
    if (!params.has("product")) return;
    const found = productOptions.find(
      (item) => item.value == params.get("product"),
    );
    if (found) {
      setProductName(found.label);
    }
  }, [productOptions]);

  return (
    <section
      className="Query_Form"
      style={{
        backgroundImage: `url(${backgroundImage})`,
      }}
    >
      <Formik
        validateOnMount
        innerRef={formikRef}
        initialValues={initialValues}
        validationSchema={STEP_VALIDATION[step]}
        onSubmit={handleSubmit}
        enableReinitialize
      >
        {({
          errors,
          touched,
          setFieldValue,
          values,
          setValues,
          handleChange,
          resetForm,
          dirty,
        }) => {
          const isSubmitDisabled =
            !!Boolean(Object.keys(errors).length) ||
            (step === 0 &&
              (!values.name ||
                !values.workEmail ||
                !values.mobileNumber ||
                !values.companyName)) ||
            // (step === 1 && (!otp || otp.length < OTP_LENGTH)) ||
            (step === 2 &&
              (!values.color ||
                !values.quantity ||
                (values.color === "Others" && !values.customColorValue) ||
                !values.product ||
                !preferredWeightRange)) ||
            (step == 3 &&
              (!values.businessNature ||
                !values.pincode ||
                !values.gstNumber ||
                errors.gstNumber));
          return (
            <>
              <FormikUrlSync values={values} />
              <div className={requirementFormClass + " requirementContainer "}>
                <div className={"requirementForm"}>
                  {step <= 3 && !isSubmitSuccessful ? (
                    <div className="modal__header">
                      <h1>{titleText}</h1>
                    </div>
                  ) : null}

                  {!isSubmitSuccessful ? (
                    <div className="formContent" ref={formContentRef}>
                      {step === 0 ? (
                        <>
                          <div className="field">
                            <label htmlFor="name" className="labelWidth">
                              <LabelWithTick
                                label="Name"
                                withValidation={true}
                                style={{ color: " #676773" }}
                                isValid={values?.name && !errors.name}
                                containerClass={"flex"}
                                labelClass={"label"}
                              />
                              <Field
                                type="text"
                                id="name"
                                name="name"
                                placeholder="Enter name"
                              />
                            </label>
                            {touched.name && errors.name ? (
                              <FormError
                                error={errors.name}
                                errorClass="field-error"
                              />
                            ) : null}
                          </div>

                          <div className="field">
                            <label htmlFor="email" className="labelWidth">
                              <LabelWithTick
                                label="Email ID"
                                withValidation={true}
                                style={{ color: " #676773" }}
                                isValid={values?.workEmail && !errors.workEmail}
                                labelClass={"label"}
                              />
                              <Field
                                type="email"
                                id="workEmail"
                                name="workEmail"
                                placeholder="name@company.com"
                              />
                            </label>

                            {touched.workEmail && errors.workEmail ? (
                              <FormError
                                error={errors.workEmail}
                                errorClass="field-error"
                              />
                            ) : null}
                          </div>

                          <div className="field-contact field">
                            <label htmlFor="contact" className="labelWidth">
                              <LabelWithTick
                                label="Mobile number"
                                withValidation={true}
                                style={{ color: " #676773" }}
                                isValid={
                                  values?.mobileNumber &&
                                  isValidPhoneNumber(values?.mobileNumber)
                                }
                                labelClass={"label"}
                              />

                              <div className="field-contact">
                                <Phone
                                  value={values?.mobileNumber}
                                  onChange={(value) => {
                                    if (!value || !value.startsWith("+91")) {
                                      setFieldValue("mobileNumber", "+91");
                                      setMobile("+91");
                                      return;
                                    }
                                    setFieldValue("mobileNumber", value);
                                    setMobile(value);
                                  }}
                                  // To prevent cursor placement behind +91(IN) : might update in future for different country codes
                                  onKeyDown={(e) => {
                                    const { selectionStart } = e.target;
                                    if (
                                      selectionStart <= 3 &&
                                      (e.key === "Backspace" ||
                                        e.key === "ArrowLeft")
                                    ) {
                                      e.preventDefault();
                                    }
                                  }}
                                  onSelect={(e) => {
                                    if (e.target.selectionStart < 3) {
                                      e.target.setSelectionRange(3, 3);
                                    }
                                  }}
                                  defaultCountry="IN"
                                  country="IN"
                                  international
                                  countryCallingCodeEditable={false}
                                  countrySelectProps={{
                                    disabled: true,
                                  }}
                                  placeholder="Mobile number"
                                  id="mobileNumber"
                                  name="mobileNumber"
                                />
                              </div>
                            </label>
                            {touched.mobileNumber && errors.mobileNumber ? (
                              <FormError
                                error={errors.mobileNumber}
                                errorClass="field-error"
                              />
                            ) : null}
                          </div>

                          <div className="field">
                            <label htmlFor="name" className="labelWidth">
                              <LabelWithTick
                                label="Company name"
                                withValidation={true}
                                style={{ color: " #676773" }}
                                isValid={
                                  values?.companyName && !errors.companyName
                                }
                                containerClass={"flex"}
                                labelClass={"label"}
                              />
                              <Field
                                type="text"
                                id="companyName"
                                name="companyName"
                                placeholder="Enter company name"
                              />
                            </label>
                            {touched.companyName && errors.companyName ? (
                              <FormError
                                error={errors.companyName}
                                errorClass="field-error"
                              />
                            ) : null}
                          </div>
                        </>
                      ) : null}

                      {/* Disabled step 1 : 05-02-2026. Now we will jump from step 0 -> 1 */}
                      {/* {step === 1 ? (
                        <>
                          <div className="customer_otp_section">
                            {showOTPError ? (
                              <p className="leads_error">
                                <span className="leads_error_text">
                                  {showOTPError}
                                </span>

                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="24"
                                  height="24"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  className="leads_error_icon"
                                  onClick={() => {
                                    setShowOTPError(false);
                                  }}
                                >
                                  <g clip-path="url(#clip0_154_2369)">
                                    <path
                                      d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z"
                                      fill="white"
                                    />
                                  </g>
                                  <defs>
                                    <clipPath id="clip0_154_2369">
                                      <rect
                                        width="24"
                                        height="24"
                                        fill="white"
                                      />
                                    </clipPath>
                                  </defs>
                                </svg>
                              </p>
                            ) : null}

                            <div className="customer_otp_heading">
                              <p>
                                Enter OTP sent to your mobile{" "}
                                <span>{maskMobileNumber(mobile)}</span>
                              </p>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="20"
                                height="20"
                                viewBox="0 0 20 20"
                                fill="none"
                                className="product_lead_otp_icon"
                                onClick={() => {
                                  setOtp(null);
                                  setStep(0);
                                }}
                              >
                                <g clip-path="url(#clip0_21_7511)">
                                  <path
                                    d="M4.1665 13.4031V15.8333H6.59672L13.7642 8.6658L11.334 6.23558L4.1665 13.4031ZM15.6436 6.78643C15.8964 6.53369 15.8964 6.12541 15.6436 5.87267L14.1272 4.35621C13.8744 4.10347 13.4661 4.10347 13.2134 4.35621L12.0274 5.54216L14.4577 7.97238L15.6436 6.78643Z"
                                    fill="#0067E2"
                                  />
                                </g>
                                <defs>
                                  <clipPath id="clip0_21_7511">
                                    <rect width="20" height="20" fill="white" />
                                  </clipPath>
                                </defs>
                              </svg>
                            </div>
                            <OTPInput
                              value={otp}
                              onChange={(value) => {
                                setShowOTPError(null);
                                const numericOtp = value.replace(/\D/g, "");
                                setOtp(numericOtp);

                                if (numericOtp.length === OTP_LENGTH) {
                                  handleSubmitStepFirst(
                                    { values },
                                    null,
                                    numericOtp,
                                  );
                                }
                              }}
                              numInputs={OTP_LENGTH}
                              inputType="tel"
                              inputStyle="customer_otp_input"
                              containerStyle="otp_input_container"
                              renderInput={(props) => (
                                <input
                                  {...props}
                                  inputMode="numeric"
                                  pattern="[0-9]*"
                                />
                              )}
                            />

                            <div className="reset_button_container">
                              <button
                                className="customer_reset_btn"
                                disabled={actionButtonsDisabled}
                                onClick={() => {
                                  onResendClick();
                                }}
                              >
                                Resend OTP
                              </button>
                              {actionButtonsDisabled ? (
                                <CountdownCircleTimer
                                  colors={"#0067e2"}
                                  isPlaying
                                  duration={60}
                                  size={28}
                                  strokeWidth={3}
                                  strokeLinecap={0}
                                  trailStrokeWidth={0}
                                  onComplete={onResendWaitComplete}
                                >
                                  {({ remainingTime }) => (
                                    <div className="flex relative justify-center items-center w-full h-full">
                                      <div className="countdownBackground" />
                                      <div className="countdownTime">
                                        {remainingTime}
                                      </div>
                                    </div>
                                  )}
                                </CountdownCircleTimer>
                              ) : null}
                            </div>
                          </div>
                        </>
                      ) : null} */}

                      {step === 2 ? (
                        <>
                          {/* <div className="field">
                            <LabelWithTick
                              label="Requirement Type"
                              withValidation={true}
                              style={{ color: "#676773" }}
                              isValid={values?.requirementType != ""}
                              labelClass={"label"}
                            />
                            <div
                              role="group"
                              className="checkbox-group"
                              aria-labelledby="checkbox-group"
                            >
                              {productRequirementTypes.map(
                                (requirementType) => (
                                  <label
                                    key={requirementType}
                                    className="radioButton no_margin_radio_button"
                                  >
                                    <Field
                                      type="radio"
                                      name="requirementType"
                                      value={requirementType}
                                      onClick={() => {
                                        setFieldValue(
                                          "requirementType",
                                          requirementType,
                                        );
                                        setFieldValue("product", "");
                                        setProductQualities([]);
                                        handleRequirementTypeChange(
                                          values.productLeadType,
                                          requirementType,
                                        );
                                      }}
                                    />
                                    <span>{requirementType}</span>
                                  </label>
                                ),
                              )}
                              {touched.requirementType &&
                              errors.requirementType ? (
                                <FormError
                                  error={errors.requirementType}
                                  errorClass="field-error"
                                />
                              ) : null}
                            </div>
                            <div className="info_text_div">
                              {values.requirementType == "Bottomwear" && (
                                <p className="info_text_div__text">
                                  Ex., pants, skirts, etc.
                                </p>
                              )}

                              {values.requirementType == "Topwear" && (
                                <p className="info_text_div__text">
                                  Ex., shirts, kurtis, etc.
                                </p>
                              )}
                            </div>
                          </div> */}
                          <div className="field">
                            <LabelWithTick
                              label="Preferred weight range"
                              withValidation={true}
                              style={{ color: "#676773" }}
                              labelClass={"label"}
                              isValid={!!preferredWeightRange}
                            />

                            <div
                              role="group"
                              className="checkbox-group"
                              aria-labelledby="weight-range-group"
                            >
                              <label
                                className={`radioButton ${
                                  preferredWeightRange === "LESS"
                                    ? "selected"
                                    : ""
                                }`}
                              >
                                <input
                                  type="radio"
                                  name="preferredWeightRange"
                                  value="LESS"
                                  checked={preferredWeightRange === "LESS"}
                                  onChange={() => {
                                    setPreferredWeightRange("LESS");
                                    setKeyInParams(
                                      "preferredWeightRange",
                                      "LESS",
                                    );
                                    setFieldValue("product", "");
                                  }}
                                />
                                <span>{`Less than ${DENIM_FILTERED_QUANTITY} oz`}</span>
                              </label>

                              <label
                                className={`radioButton ${
                                  preferredWeightRange === "MORE"
                                    ? "selected"
                                    : ""
                                }`}
                              >
                                <input
                                  type="radio"
                                  name="preferredWeightRange"
                                  value="MORE"
                                  checked={preferredWeightRange === "MORE"}
                                  onChange={() => {
                                    setPreferredWeightRange("MORE");
                                    setKeyInParams(
                                      "preferredWeightRange",
                                      "MORE",
                                    );
                                    setFieldValue("product", "");
                                  }}
                                />
                                <span>{`More than ${DENIM_FILTERED_QUANTITY} oz`}</span>
                              </label>
                            </div>
                          </div>

                          {preferredWeightRange !== null ? (
                            <div className="field">
                              <LabelWithTick
                                label="What product are you looking for?"
                                withValidation={true}
                                style={{ color: " #676773" }}
                                isValid={values.product}
                                labelClass={"label"}
                              />
                              <div
                                role="group"
                                className="checkbox-group"
                                aria-labelledby="product-group"
                              >
                                {productOptionsWithOther.map((option) => (
                                  <label
                                    key={option.value}
                                    className="radioButton"
                                  >
                                    <Field
                                      type="radio"
                                      name="product"
                                      value={option.value}
                                      checked={values.product == option.value}
                                      onClick={() => {
                                        setFieldValue("product", option.value);

                                        if (option.value === "Others") {
                                          setProductName("");
                                          setCustomProduct("");
                                          setKeyInParams("product", "Others");
                                        } else {
                                          setProductName(option.label);
                                          setKeyInParams(
                                            "product",
                                            option.value,
                                          );
                                          setFieldValue(
                                            "customProductValue",
                                            "",
                                          );
                                        }
                                      }}
                                    />
                                    <ProductLabel
                                      label={option.label}
                                      className={`${values.product == option.value ? "productLabelSelectedSpan" : ""}`}
                                    />
                                  </label>
                                ))}

                                {touched.product && errors.product ? (
                                  <FormError
                                    error={errors.product}
                                    errorClass="field-error"
                                  />
                                ) : null}
                              </div>
                            </div>
                          ) : null}

                          {/* {values.product === "Others" && (
                            <Field name="customProductValue">
                              {({ field }) => (
                                <input
                                  type="text"
                                  className="otherInput"
                                  placeholder="Enter Product"
                                  {...field}
                                  onChange={(e) => {
                                    const val = e.target.value;
                                    setCustomProduct(val);
                                    setProductName(val);
                                    setFieldValue("customProductValue", val);
                                    setKeyInParams("product", val);
                                  }}
                                />
                              )}
                            </Field>
                          )} */}

                          <div className="field">
                            <LabelWithTick
                              label="Color"
                              withValidation={true}
                              style={{ color: "#676773" }}
                              isValid={
                                values.color &&
                                (values.color !== "Others" ||
                                  !!values.customColorValue)
                              }
                              labelClass={"label"}
                            />
                            <div
                              role="group"
                              className="checkbox-group"
                              aria-labelledby="checkbox-group"
                            >
                              {productColors.map((color) => (
                                <label
                                  key={color}
                                  className="radioButton no_margin_radio_button"
                                >
                                  <Field
                                    type="radio"
                                    name="color"
                                    value={color}
                                    onClick={() => {
                                      setFieldValue("color", color);
                                      if (color !== "Others") {
                                        setCustomColor("");
                                        setFieldValue("customColorValue", "");
                                      }
                                    }}
                                  />
                                  <span>{color}</span>
                                </label>
                              ))}
                              {touched.color && errors.color ? (
                                <FormError
                                  error={errors.color}
                                  errorClass="field-error"
                                />
                              ) : null}
                            </div>
                          </div>

                          {values.color === "Others" && (
                            <Field name="customColorValue">
                              {({ field }) => (
                                <input
                                  type="text"
                                  className="otherInput"
                                  placeholder="Enter color"
                                  {...field}
                                  onChange={(e) => {
                                    setCustomColor(e.target.value);
                                    setFieldValue(
                                      "customColorValue",
                                      e.target.value,
                                    );
                                  }}
                                />
                              )}
                            </Field>
                          )}

                          <div className="field">
                            <LabelWithTick
                              label="Quantity required"
                              withValidation={true}
                              style={{ color: "#676773" }}
                              isValid={values?.quantity != ""}
                              labelClass={"label"}
                            />
                            <div
                              role="group"
                              className="checkbox-group"
                              aria-labelledby="checkbox-group"
                            >
                              {productRequiredQuantity.map((quantity) => (
                                <label key={quantity} className="radioButton">
                                  <Field
                                    type="radio"
                                    name="quantity"
                                    value={quantity.label}
                                    onClick={() => {
                                      setFieldValue("quantity", quantity.label);
                                      setFieldValue(
                                        "minQuantity",
                                        quantity.minQuantity,
                                      );
                                      setFieldValue(
                                        "maxQuantity",
                                        quantity.maxQuantity,
                                      );
                                    }}
                                  />
                                  <span>{quantity.label}</span>
                                </label>
                              ))}
                              {touched.quantity && errors.quantity ? (
                                <FormError
                                  error={errors.quantity}
                                  errorClass="field-error"
                                />
                              ) : null}
                            </div>
                          </div>
                        </>
                      ) : null}

                      {step === 3 ? (
                        <>
                          <div className="field">
                            <LabelWithTick
                              label="Business Nature"
                              withValidation={true}
                              style={{ color: "#676773" }}
                              isValid={values?.businessNature !== ""}
                              labelClass={"label"}
                            />

                            <div
                              role="group"
                              className="checkbox-group"
                              aria-labelledby="checkbox-group"
                            >
                              {Object.entries(BUSINESS_NATURE).map(
                                ([key, value]) => (
                                  <label key={key} className="radioButton">
                                    <Field
                                      type="radio"
                                      name="businessNature"
                                      value={key}
                                      checked={values.businessNature === key}
                                      onClick={() => {
                                        setFieldValue("businessNature", key);
                                      }}
                                    />
                                    <span>{value}</span>
                                  </label>
                                ),
                              )}
                            </div>
                          </div>

                          <div className="field">
                            <label htmlFor="contact" className="labelWidth">
                              <LabelWithTick
                                label="GST Number"
                                withValidation={true}
                                style={{ color: " #676773" }}
                                isValid={
                                  values?.gstNumber &&
                                  !errors.gstNumber &&
                                  !gstNumberErrorMessage
                                }
                                labelClass={"label"}
                              />

                              <div className="leads_input_with_verify">
                                <Field
                                  name="gstNumber"
                                  className="input leads_input_has_verify"
                                  onChange={(e) => {
                                    const capitalizedValue =
                                      e.target.value.toUpperCase();
                                    setFieldValue(
                                      "gstNumber",
                                      capitalizedValue,
                                    );
                                    params.set("gstNumber", capitalizedValue);
                                    setIsGstVerified(null);
                                    setGstNumberErrorMessage(null);
                                    setLeadCompanyName("");
                                    setPincode("");
                                  }}
                                />

                                {isGstVerified === null && (
                                  <button
                                    type="button"
                                    className={`leads_verify ${
                                      values?.gstNumber && !errors.gstNumber
                                        ? "leads_verify--enabled"
                                        : "leads_verify--disabled"
                                    }`}
                                    disabled={
                                      !values?.gstNumber || errors.gstNumber
                                    }
                                    onClick={() => {
                                      handleGSTVerification(
                                        values?.gstNumber,
                                        setFieldValue,
                                      );
                                      setFieldValue(
                                        "gstNumber",
                                        values?.gstNumber,
                                      );
                                    }}
                                  >
                                    <p>Verify</p>
                                    <img
                                      src={
                                        values?.gstNumber && !errors.gstNumber
                                          ? chevronRightEnabled
                                          : chevronRightDisabled
                                      }
                                      alt={`${isGstVerified ? "valid-gst" : "invalid-gst"}`}
                                    />
                                  </button>
                                )}

                                {isGstVerified === false && (
                                  <img
                                    src={disableIcon}
                                    alt="invalid-gst"
                                    className="leads_verify leads_verify_img"
                                  />
                                )}

                                {isGstVerified === true && (
                                  <img
                                    src={validIcon}
                                    alt="valid-gst"
                                    className="leads_verify leads_verify_img"
                                  />
                                )}
                              </div>
                            </label>

                            {errors.gstNumber && touched.gstNumber && (
                              <FormError
                                error={
                                  gstNumberErrorMessage || errors.gstNumber
                                }
                              />
                            )}
                            {isGstVerified === false && (
                              <>
                                <FormError
                                  error={
                                    gstNumberErrorMessage || errors.gstNumber
                                  }
                                />
                              </>
                            )}
                          </div>
                          {isGstVerified === true ? (
                            <>
                              <div className="leads_company_container">
                                <div className="leads_company_block">
                                  <div className="leads_company_label">
                                    Company registered name
                                  </div>

                                  <div className="leads_company_value">
                                    {leadCompanyName}
                                  </div>
                                </div>
                              </div>
                            </>
                          ) : null}

                          <div className="field">
                            <label htmlFor="name" className="labelWidth">
                              <LabelWithTick
                                label="Pincode"
                                withValidation={true}
                                style={{ color: " #676773" }}
                                isValid={values?.pincode && !errors.pincode}
                                containerClass={"flex"}
                                labelClass={"label"}
                              />
                              <Field
                                type="text"
                                id="pincode"
                                name="pincode"
                                placeholder="Enter Pincode"
                              />
                            </label>
                            {touched.pincode && errors.pincode ? (
                              <FormError
                                error={errors.pincode}
                                errorClass="field-error"
                              />
                            ) : null}
                          </div>
                        </>
                      ) : null}
                    </div>
                  ) : (
                    <div className="query_successful_container">
                      <div className="query_success_inner_container">
                        <div className="tickImg">
                          <img src={greenTick} alt="icon" />
                        </div>
                        <div>
                          <p className="successTitle">
                            Thank you for your interest!
                          </p>
                          <p className="successSubTxt">
                            One of our fabric experts will reach you in 24
                            hours.
                          </p>
                        </div>
                        <p className="successSubTxt">
                          Think Fabric. Think Locofast.
                        </p>
                      </div>
                    </div>
                  )}
                  {!isSubmitSuccessful ? (
                    <div
                      className={"flex-center submit__container " + footerClass}
                    >
                      <button className="cross" type="button">
                        {""}
                      </button>

                      <button
                        type="submit"
                        className="btn btn-primary buttonWidth lead_submit_button"
                        value="submit"
                        onClick={() => handleSubmit({ values, resetForm })}
                        disabled={isSubmitDisabled}
                      >
                        {submitText}
                      </button>
                    </div>
                  ) : null}
                </div>
              </div>
            </>
          );
        }}
      </Formik>
    </section>
  );
};
export default QueryForm;
